import $ from 'jquery';

function autosubmitForm(): void {
  document
    .querySelectorAll('form.js-autosubmit')
    .forEach((form) => (form as HTMLFormElement).requestSubmit());
}

autosubmitForm();

$(document).on('ready turbo:render turbo:frame-render', function () {
  autosubmitForm();
});

$(document).on('change', '.js-autosubmit', function () {
  $(this).closest('form').trigger('submit');
});
